import React, { Component, PropTypes } from 'react';
import { Link, browserHistory } from 'react-router';
import groupBy from 'lodash/groupBy';
import classnames from 'classnames';
import Money from 'common/components/money';
import SubcategoryIcon from 'common/components/subcategory_icon';

export default class SubCategories extends Component {
  constructor(props) {
    super(props);

    this.renderItem = this.renderItem.bind(this);
    this.renderSubcat = this.renderSubcat.bind(this);
  }

  renderSubcat(item) {
    const subcat = this.props.subcats.find(s => s.slug === item.slug);
    const papLink = `/start-a-project/${subcat.category.slug}/${subcat.slug}/details/package/`;

    return (
      <div className="columns small-16 medium-8 large-4" key={subcat.id}>
        <div className="tile subcategory" onClick={() => browserHistory.push(papLink)}>
          <SubcategoryIcon subcat={subcat} />
          <h3 className="as-h4-important">{ subcat.name }</h3>
          <p className="description">{ subcat.description }</p>
          <div className="pricing">
            <label>From</label>
            <Money className="min-price" value={ subcat.minimum_price } />
          </div>
          <div className="actions">
            <Link className="btn btn-primary">Start</Link>
          </div>
        </div>
      </div>
    );
  }

  renderTestimonial(testimonial) {
    return (
      <div className={classnames('columns', testimonial.width || 'medium-8')} key={testimonial.name}>
        <div className="testimonial">
          <div className="row">
            <div className="columns small-8 small-offset-4 medium-4 medium-offset-0 text-center">
              <img className="avatar avatar-lg avatar-round avatar-shadow" src={testimonial.avatar}/>
            </div>
            <div className="columns small-14 small-offset-1 medium-12 medium-offset-0">
              <div className="testimonial-text">
                <p>{ testimonial.text }</p>
                <div className="attribution">
                  <div className="name">{ testimonial.name }</div>
                  <div className="description">{ testimonial.description }</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderItem(item) {
    if (item.type === "sub_category") {
      return this.renderSubcat(item);
    }

    return this.renderTestimonial(item);
  }

  render() {
    const { title, subtitle, background, subcats, items, cta, groupByCategory } = this.props;
    const byCat = groupBy(items, item => {
      if (item.type === "testimonial") {
        return item.categoryName;
      }
      return subcats.find(s => s.slug === item.slug).category.name;
    });

    return (
      <div className={classnames("block block-sub-categories", background)}>
        { !!title &&
        <div className="row columns">
          <div className="block-header">
            <h2>{ title }</h2>
            { !!subtitle && <h3 className="subtitle">{ subtitle }</h3> }
          </div>
        </div> }

        { groupByCategory?
        <div>
          { Object.keys(byCat).map(catName => (
          <div key={catName} className="category">
            { catName !== "undefined" &&
            <div className="row">
              <div className="columns small-16">
                <h3>{ catName }</h3>
              </div>
            </div> }
            <div className="row">
              { byCat[catName].map(this.renderItem) }
            </div>
          </div>
          )) }
        </div> :
        <div className="row">
          { items.map(this.renderItem) }
        </div> }

        { !!cta &&
        <h3 className="text-center cta">
          <Link to={cta.link}>{ cta.label }</Link>
        </h3> }
      </div>
    );
  }
}

SubCategories.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  background: PropTypes.string,
  subcats: PropTypes.array.isRequired,
  items: PropTypes.array.isRequired,
  cta: PropTypes.object,
  groupByCategory: PropTypes.bool
}
